import { type App, inject, type InjectionKey } from 'vue';

export function resolveFromApp<T>(app: App, key: InjectionKey<T> | string): T {
  const service = app.runWithContext(() => inject(key));

  if (service === undefined) {
    throw new Error(`Cannot resolve ${String(key)} dependency. Make sure it has been registered before.`);
  }

  return service;
}
